// Shared by CMS detection and rendering so layout precedence stays identical.
// GraphQL aliases the CMS field to content_type. Presence of that queried field
// wins deliberately, even when empty/null; otherwise inspect the raw CMS field.
function getFilteredContentType(elements) {
    const field = Object.prototype.hasOwnProperty.call(
        elements || {},
        'content_type'
    )
        ? elements.content_type
        : elements?.content_type_a20cc11;
    return field?.value?.[0]?.codename || undefined;
}

function getFilteredContentDataset(layout, contentType) {
    if (!layout) return null;
    if (layout === 'news_and_media' || contentType === 'publication') {
        return 'pagePublications';
    }
    if (layout === 'faqs' || contentType === 'faq') return 'pageFaqs';
    if (contentType === 'support') return 'pageSupport';
    if (contentType === 'case_study') return 'pageResearch';
    return contentType === 'product' ? null : 'pageBlogs';
}

module.exports = { getFilteredContentDataset, getFilteredContentType };
